import { render, staticRenderFns } from "./AvatarCreate.vue?vue&type=template&id=74b3110e&scoped=true&"
import script from "./AvatarCreate.vue?vue&type=script&lang=js&"
export * from "./AvatarCreate.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCreate.vue?vue&type=style&index=0&id=74b3110e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b3110e",
  null
  
)

export default component.exports